/**
 * The Baxter mark. The body is data so `BAXTER_DOG_MARKUP` can serve the places
 * that take an HTML string rather than a React node (the GrapesJS canvas
 * toolbar, AB#810) — one source, so the dog can never drift into two dogs.
 */
const PARTS: { className?: string; d: string; fill?: string }[] = [
  { d: 'M5 6h5V3h2v1h2v2h2v3h-4v2H4V9h1z' },
  { className: 'baxter-dog-tail', d: 'M1 5h2v2h2v2H2V7H1z' },
  { d: 'M12 5h1v1h-1z', fill: 'var(--card)' },
  { className: 'baxter-dog-stride', d: 'M4 11h2v3H3v-1h1zM10 11h2v3h2v1h-4z' },
  { className: 'baxter-dog-stride baxter-dog-stride-back', d: 'M4 11h2v2h2v1H4zM10 11h2v2h-2v2H8v-1h2z' },
];

export const BAXTER_DOG_MARKUP = `<svg class="baxter-dog" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" shape-rendering="crispEdges" aria-hidden="true">${
  PARTS.map((part) => `<path${part.className ? ` class="${part.className}"` : ''}${part.fill ? ` fill="${part.fill}"` : ''} d="${part.d}" />`).join('')
}</svg>`;

export function BaxterDog({ activity, className = 'size-[1.16375rem] text-primary' }: { activity?: string; className?: string }) {
  return <svg data-activity={activity} className={`baxter-dog shrink-0 fill-current ${className}`} viewBox="0 0 16 16" shapeRendering="crispEdges" aria-hidden="true">
      {PARTS.map((part) => <path key={part.d} className={part.className} fill={part.fill} d={part.d} />)}
    </svg>;
}
